import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { AppStateProvider } from 'providers/AppState';
import './Sentry';
import 'styles/resetAntd.css';
import 'styles/app.css';
import './modules/dayjs-setup';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <AppStateProvider>
    <App />
  </AppStateProvider>,
);
